module.exports = __webpack_public_path__ + "img/sketch.7ca34293.png";